import { createFileRoute } from '@tanstack/react-router';
import { PublicLayout } from '../app/layouts/public-layout';

/** Public pages: `.theme-oex`, no sign-in. */
export const Route = createFileRoute('/_public')({ component: PublicLayout });
